<template>
  <div>
    <div 
      id="popup"
      class="px-5"
      v-if="popupVisible && parkingLot">
      <div 
        @click="popupVisible=false" 
        class="h-100 w-100 position-fixed z-1">
      </div>
      <div class="bg-white expanded rounded-4 p-3 z-2 position-relative">
        <i 
          class="fa-solid fa-xmark position-absolute fs-2"
          style="top: 10px;right: 20px;"
          @click="popupVisible=false; trackMixPanel('garagepopup_click_close')" ></i>
        <img 
          src="../assets/popup_garaje_driver.png" 
          class="card-img-top rounded-4 mb-0" 
          alt="...">
        <h3 class="text-center mb-1">¿No te encaja esta plaza?</h3>
        <p class="text-center mb-1 fw-bold">
          <br>
          No te preocupes, ¡tenemos más!
          
        </p>
        <p class="text-center mb-1">Solo dinos cuándo y dónde necesitas aparcar aquí:</p>
        <div 
          class="row">
          <router-link
            to="/create-driver"
            @click="trackMixPanel('garagepopup_click_solicitar nuevo garaje')"
            style="background-color: #011638;"
            class="btn my-3 btn-dark mx-auto col-6" >
            Solicitar garaje
          </router-link>
        </div>
      </div>
    </div>
    <div 
      v-if="parkingLot!=null" 
      class="h-100"
      style="overflow-y: auto;">
      <i
        class="fa-solid fa-angle-left px-3 py-2 text-center bg-white position-absolute"
        style="color:#011638; border-radius: 12px;font-size: 1.3rem; top: 15px; left: 15px;"
        @click="$router.go(-1);"
      />
      <div style="height: calc(100% - 85px) !important; overflow-y: scroll;">
        <img
          v-if="parkingLot.images && parkingLot.images.length == 0"
          :src="noPhoto"
          style="height: 25vh; object-fit: cover; width: 100%;"
        >
        <div
          v-else
          id="carouselExampleIndicators"
          class="carousel slide"
          style="height: 25vh; object-fit: cover; width: 100%;"
        >
          <div class="carousel-inner h-100">
            <div
              v-for="(img, index) in parkingLot.images"
              :id="'img'+index"
              :key="index"
              class="h-100 carousel-item"
              :class="index === 0 ? 'active' : ''"
            >
              <img
                :src="getImageUrl(img)"
                style="object-fit: cover;"
                class="d-block w-100 h-100"
                alt="..."
              >
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span
              class="carousel-control-prev-icon"
              aria-hidden="true"
            />
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span
              class="carousel-control-next-icon"
              aria-hidden="true"
            />
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <div class="px-3 mt-3">
          <div class="row m-0">
            <div class="col-12 col-sm-8">
              <a
                :href="parkingLot.location
                  ? 'https://www.google.com/maps?q=' + parkingLot.location.latitude + ',' + parkingLot.location.longitude
                  : '#'"
                target="_blank"
                class="mb-1 fw-semibold text-decoration-none"
                style="color:#011638; font-size: 1rem;"
              >
                Alquiler de Garaje en {{ parkingLot.address.street }}
              </a>
              <p
                class="mb-0"
                style="color:#56647A; font-size: 0.9rem;"
              >
                {{ parkingLot.address.zip_code }}<span v-if="parkingLot.address.zip_code">,</span> {{ parkingLot.address.city }}
              </p>
            </div>
            <div
              class="col-12 col-sm-4 d-flex justify-content-sm-end justify-content-start align-items-center mt-2"
            >
              <h5
                style="font-size: 1.3rem; color:#56647A"
                class="fw-semibold mb-0 ellipsis"
              >
                <span v-if="parkingLot.start_hour == 0 && parkingLot.end_hour == 0">
                  {{ parkingLot.monthly_price/2 }}€
                </span>
                <span v-else>
                  {{ parkingLot.monthly_price }}€
                </span>
                <span
                  style="font-size: 1rem; color:#56647A"
                  class="fw-light"
                >/mes</span>
              </h5>
            </div>
          </div>
          <div
            class="bg-white rounded-4 p-3 my-3"
            style="color:#011638"
          >
            <!--<div class="row">
              <p class="col mb-0">
                Tiempo andando
              </p>
              <p
                class="col text-end mb-0"
                style="color:#8E97A7"
              >
                3min <i class="fa-solid fa-person-walking ms-2" />
              </p>
            </div>
            <hr>-->
            <div class="d-flex justify-content-between align-items-center">
              <span
                class="mb-0 pe-2"
                style="color: #011638"
              >
                Horario
              </span>
              <span
                class="text-end mb-0"
                style="color:#8E97A7"
              >
                <span
                  v-if="parkingLot.start_hour!=null && parkingLot.end_hour!=null"
                  class="mb-0"
                  style="color:#011638"
                >
                  L-V
                  <span
                    v-if="parkingLot.start_hour == 0 && parkingLot.end_hour == 0"
                    class="fw-bold"
                  >
                    A elegir
                    <!--24h
                    <i
                      v-if="parkingLot.start_hour == '00:00' && parkingLot.end_hour == '00:00'"
                      class="fa-solid fa-check ms-2 text-success"
                    />-->
                  </span>
                  <span v-else>{{ formatTime(parkingLot.start_hour) }}h - {{ formatTime(parkingLot.end_hour) }}h</span>
                </span>
                <span
                  class="mb-0"
                  style="color:#011638"
                  v-if="parkingLot.weekend_full_day"
                >
                  S-D 24h
                </span> 
                <i class="fa-regular fa-clock ms-2" />
              </span>
            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center">
              <span
                style="color: #011638"
                class="mb-0 pe-2"
              >
                Tamaño
              </span>
              <span
                class="col text-end mb-0"
                style="color:#8E97A7"
              >
                <span style="color: #011638">{{ formatSize(parkingLot.vehicle_size) }}</span> <i class="fa-solid fa-up-right-and-down-left-from-center ms-2" />
              </span>
            </div>
            <hr v-if="parkingLot.floor">
            <div 
              v-if="parkingLot.floor"
              class="d-flex justify-content-between align-items-center">
              <span
                style="color: #011638"
                class="mb-0 me-2"
              >
                Planta
              </span>
              <span
                class="text-end mb-0"
                style="color:#8E97A7"
              >
                <span style="color: #011638">
                  {{ getFloorLabel(parkingLot.floor) }}
                </span>
                <i class="fa-solid fa-elevator ms-2" />
              </span>
            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center">
              <span
                style="color: #011638"
                class="mb-0 pe-2"
              >
                Periodo de alquiler
              </span>
              <span
                class="text-end mb-0"
                style="color:#8E97A7"
              >
                <span style="color: #011638">
                  {{ formattedPeriod }}
                </span>
                <i class="fa-regular fa-calendar ms-2" />
              </span>
            </div>
          </div>
          <div v-if="parkingLot.comments || (parkingLot?.tags?.lenght > 0)">
            <p
              style="color:#56647A; font-size: 0.9rem;"
              class="mb-1 ms-2"
            >
              INFORMACIÓN SOBRE EL GARAJE
            </p>
            <div
              class="bg-white rounded-4 p-3 mb-3"
              style="color:#011638"
            >
              <p v-if="parkingLot.comments">
                {{ parkingLot.comments }}
              </p>
              <hr>
              <div class="d-flex flex-wrap">
                <div class="d-flex flex-wrap">
                  <span
                    v-for="(tag, index) in parkingLot?.tags"
                    :key="index"
                    class="etiqueta"
                  >
                    {{ formatTag(tag) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <a
            :href="parkingLot.location
              ? 'https://www.google.com/maps?q=' + parkingLot.location.latitude + ',' + parkingLot.location.longitude
              : '#'"
            target="_blank"
            class="text-decoration-none"
          >
            <div
              id="map"
              style="width: 100%; height: 120px; border-radius: 20px 20px 0px 0px; z-index:0 !important"
            />
            <div
              class="p-3"
              style="background-color: white; border-radius: 0px 0px 20px 20px;"
            >
              <h4
                class="mb-1"
                style="color:#011638; font-size: 1.1rem;"
              >
                Alquiler de Garaje en
                <span style="color:#15E0DD">
                  {{ parkingLot.address.street }}</span>
              </h4>
              <p
                class="mb-0"
                style="color:#56647A; font-size: 0.9rem;"
              >
                {{ parkingLot.address.zip_code }}<span v-if="parkingLot.address.city">,</span> {{ parkingLot.address.city }}
              </p>
            </div>
          </a>
          <div
            class="p-3 my-3 row m-0"
            style="background-color: white; border-radius: 20px;"
          >
            <div class="col-2 d-flex align-items-center p-0">
              <img
                src="../../src/assets/user_image.png"
                style="border-radius: 100; width: 100%;height: auto;"
              >
            </div>
            <div class="col-9 pt-2">
              <h4
                class="mb-0"
                style="color:#011638; font-size: 1.1rem;"
              >
                {{ parkingLot.user.name }} {{ parkingLot.user.surname }}
              </h4>
              <p
                style="color:#8E97A7; font-size: 0.8rem;"
              >
                Parker
              </p>
            </div>
            <!--<i
              class="fa-solid fa-angle-right text-center col-1 p-0 d-flex align-items-center"
              style="color:#8E97A7; font-size: 1rem;"
            />-->
          </div>
        </div>
      </div>
      <div
        class="px-2 py-3 row m-0 position-fixed bottom-0 w-100 "
        style="background-color: white; border-radius: 20px 20px 0px 0px;
          color:#011638; height: 85px;"
      >
        <div class="col-6">
          <h4
            class="mb-1 fw-semibold ellipsis"
            style="font-size: 1.1rem;"
          >
            Garaje de {{ parkingLot.user.name }}
          </h4>
          <h3 class="fw-semibold mb-0">
            <span v-if="parkingLot.start_hour == 0 && parkingLot.end_hour == 0">
              {{ parkingLot.monthly_price/2 }}€
            </span>
            <span v-else>
              {{ parkingLot.monthly_price }}€
            </span>
            <span
              style="font-size: 1rem; color:#56647A"
              class="fw-light"
            >/mes</span>
          </h3>
        </div>
        <div class="col-6 d-flex align-items-center">
          <button
            v-if="parkingLot.status === 'available'"
            class="btn rounded-4 fw-bold px-4 py-2 w-100"
            style="background-color: #15E0DD; color:#011638"
            @click="request_parking(parkingLot.id)"
          >
            Solicitar visita
          </button>

          <button
            v-if="parkingLot.status === 'rented'"
            class="btn rounded-4 fw-bold px-4 py-2 w-100"
            style="background-color: #FF0000; color:#FFFFFF"
            disabled
          >
            Alquilado
          </button>
        </div>
      </div>
      <drawer-login
        ref="drawer_login"
        :is_driver="true"
        @login-completed="/*this.trackMixPanel('USUARIO LOGUEADO'),*/request_parking(parkingLot.id)"
        @confirm-mail="this.trackMixPanelLogin('appconfirmmaildriver_click_confirmar', false)"
        @confirm-personal-data="this.trackMixPanelLogin('appconfirmmaildriver_click_confirmar', true)"
      />
    </div>
    <div
      v-else
      class="d-flex align-items-center "
      style="height: 100% !important;">
      <div class="pb-5">
        <div class="d-flex justify-content-center mb-5">
          <img 
            src="../assets/parker_notFound.png" 
            style="width: 80%; height: auto;"
            alt="">
        </div>
        <div>
          <h4 class="text-center px-5">
            Lo sentimos, esta plaza de garaje ya no está disponible. 
            <br>Pero no te preocupes, ¡tenemos más!
          </h4>
          <p 
            style="font-size: 1rem; color: #7a7a7a; margin-top: 0.5rem;"
            class="text-center mb-0">
            Solo dinos cuándo y dónde necesitas aparcar aquí:
          </p>
          <div class="d-flex justify-content-center">
            <router-link 
              to="/create-driver"
              style="background-color: #011638;"
              class="btn btn-dark mt-3">Solicitar garaje</router-link>
          </div>
        </div>
      </div>
    </div>
    <spinner-component
      id="spinner"
      class="d-none"
      style="z-index: 100;"></spinner-component>
  </div>
</template>
<script>
  import L from 'leaflet';
  import 'leaflet.markercluster';
  import { mapState } from 'vuex';
  import DrawerLogin from './../components/DrawerLogin.vue'
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import noPhoto from './../assets/default.jpg';
  import { formatPeriod, formatTags } from '../services/traslation';
  import mixpanel from 'mixpanel-browser';
  import axios from 'axios';
  import { useRoute } from 'vue-router'

  export default {
    name: 'FichaGaraje',
    components:{
      DrawerLogin,
      SpinnerComponent
    },
    data: function() {
      return {
        map: {},
        parkingLot: {
          "address":{},
          "user":{}
        },
        noPhoto,
        popupVisible: false,
        route: useRoute(),
        email_regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        driver_id: null
      }
    },
    computed: {
      ...mapState(['input']),
      ...mapState(['isLoggedIn']),
      ...mapState(['token']),
      formattedPeriod(){
        return formatPeriod(this.parkingLot.period)
      },
    },
    async mounted(){
      const id = this.$route.params.id; // Obtener el ID desde los parámetros de la ruta
      await this.fetchParkingLot(id);
      if(this.parkingLot){
        this.map = L.map('map', {zoomControl: false,zoomAnimation:true,fadeAnimation:true,markerZoomAnimation:true, scrollWheelZoom: true, dragging: false})
        this.map.invalidateSize()
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            maxZoom: 20,
            minZoom: 1
        }).addTo(this.map);

        // Actualizar el mapa con la ubicación del parking
        if (this.parkingLot.location) {
          this.map.setView([this.parkingLot.location.latitude, this.parkingLot.location.longitude], 15);
          const customIcon = L.icon({
            iconUrl: require('@/assets/location_icon.png'),
            iconSize: [40, 50],
            iconAnchor: [20, 30],
          });
          L.marker([this.parkingLot.location.latitude, this.parkingLot.location.longitude], { icon: customIcon }).addTo(this.map);
        }

        this.trackMixPanel("garagepage_visit")

        const email_user = this.route.query.email
        if(email_user != undefined && email_user != null && this.$refs.drawer_login.email_regex.test(email_user)){
          this.$refs.drawer_login.register_auto_user(email_user)
        }

        this.driver_id = this.route.query.driver_id

        setTimeout(() => {
          const popup = this.route.query.popup
          if(popup != "false"){
            this.popupVisible = true
          }
        }, 10000)
      }
    },
    methods: {
      trackMixPanel(mensaje){
        mixpanel.track(mensaje, {
          pantalla: 'Ficha Garaje',
          garage_id: this.parkingLot.id,
        });
      },
      trackMixPanelLogin(mensaje, isNewUser){
        let userType = isNewUser ? 'newUser' : 'existing';
        mixpanel.track(mensaje, {
          pantalla: 'Ficha Garaje',
          garage_id: this.parkingLot.id,
          userType: userType
        });
      },
      getFloorLabel(floor) {
          if (floor === 0) return "Planta Baja";
          if (floor < 0) return `Sótano ${floor}`;
          return `Planta ${floor}`;
      },
      formatTime(minutes) {
          let hours = Math.floor(minutes / 60);
          let mins = minutes % 60;

          let hoursStr = hours.toString().padStart(2, '0');
          let minsStr = mins.toString().padStart(2, '0');

          return `${hoursStr}:${minsStr}`;
        },
        formatSize(size){
          if (size == "small"){
            return "Pequeño"
          }
          if (size == "medium"){
            return "Mediano"
          }
          return "Grande"
        },
        formatTag(tag) {
          return formatTags(tag)
        },
      getImageUrl(img){
        return "https://pub-5115ef50b92446fe883b768d3193fbcc.r2.dev/" + img + ".png"
      },
      logout() {
        this.$store.commit('logout');
      },
      request_parking(id){
        this.trackMixPanel("garagepage_click_solicitar visita")
        if(!this.isLoggedIn){
          //this.trackMixPanel("ABRIR DRAWER LOGIN")
          this.$refs.drawer_login.openDrawer()
        }else{
          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")

          const apiUrl = process.env.VUE_APP_API_URL+'/api/token/verify';
          const token={
            "token": this.token
          }
          axios.post(apiUrl, token)
          .then(response => {
            spinner.classList.add("d-none")
            console.log(response)
            const param_driver_id = (this.driver_id !== null && this.driver_id !== undefined && this.driver_id !== "")
              ? `?driver_id=${this.driver_id}`
              : "";
            this.$router.push("/solicitar-garaje/"+id + param_driver_id);
          })
          .catch(error => {
            spinner.classList.add("d-none")
            this.logout()
            this.$refs.drawer_login.openDrawer()
            console.log(error)
          });          
        }
      },
      async fetchParkingLot(id) {
        try {
          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")
          const url = process.env.VUE_APP_API_URL+`/api/parking_lots/${id}`
          const response = await fetch(url);
          if (!response.ok) throw new Error('Error al obtener los datos del parking lot');
          const data = await response.json();
          this.parkingLot = data;
          console.log(this.parkingLot)
          spinner.classList.add("d-none")
        } catch (error) {
          console.error('Error fetching parking lot:', error);
          this.parkingLot = null
          spinner.classList.add("d-none")
        }
      },
    }
  }
</script>
<style scoped>
.etiqueta{
    background-color: #F5F6F8;
    border: 1px solid #E3E5E9;
    margin-right: 10px;
    padding: 4px 10px 4px 10px;
    border-radius: 5px;
    margin-bottom: 10px;
}

.ellipsis {
  white-space: nowrap;           /* Evita el salto de línea */
  overflow: hidden;              /* Oculta el texto que se desborda */
  text-overflow: ellipsis;       /* Agrega los tres puntitos (...) al final del texto */
}

#popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(139, 139, 139, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100 !important;
    transition: all 3s ease;
    backdrop-filter: blur(4px);
  }
</style>
